import { render, staticRenderFns } from "./CompanyOffersRouterLink.vue?vue&type=template&id=839c79c2&"
import script from "./CompanyOffersRouterLink.vue?vue&type=script&lang=js&"
export * from "./CompanyOffersRouterLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports